import { useState, useEffect } from 'react'

import { useMarket } from '@/utils/multi-markets/context'
import { getNavigationIcon } from '@/constants/navigationAssets'

export default function Logo(isOpen: { isOpen?: boolean }) {
  const { locale } = useMarket()
  const [logoUrl, setLogoUrl] = useState<string>('')

  useEffect(() => {
    const loadLogo = () => {
      const logoKey =
        locale === 'pl' ? 'cyfrowyParkingLogo' : 'digitalParkingLogo'
      const openedLogoKey =
        locale === 'pl' ? 'cyfrowyParkingCyanLogo' : 'digitalParkingCyanLogo'
      if (isOpen.isOpen) {
        setLogoUrl(getNavigationIcon(openedLogoKey))
        return
      }
      setLogoUrl(getNavigationIcon(logoKey))
    }

    loadLogo()
  }, [locale, isOpen])

  const ariaLabel =
    locale === 'pl' ? 'Logo Cyfrowy Parking' : 'Logo Digital Parking'

  if (!logoUrl) {
    return null
  }

  return (
    <img
      src={logoUrl}
      alt={ariaLabel}
      role="img"
      aria-label={ariaLabel}
      style={{ width: '100%', height: '100%', display: 'block' }}
    />
  )
}
